import React from 'react';
import {
    StepStrip,
    useStepStripLinks,
    type OnboardingStep,
} from '@/pages/onboarding/components/stepStrip';
import { PATH } from '@/router/PATH';

type ImportStepStripProps = {
    /** The page's branch once the flow runs; `null` while it loads. */
    branchId: string | null;
    currentStep: OnboardingStep | null;
};

/**
 * The in-shell page's strip (`shell` mode: File · Names · Products ·
 * Result) with its links back, each to `/branches/<id>/import/<step>`.
 * Nothing is a link while the page loads. Rendered inside the page's
 * `CatalogImportProvider`.
 */
export const ImportStepStrip: React.FC<ImportStepStripProps> = ({
    branchId,
    currentStep,
}) => {
    const pathOf = React.useCallback(
        (step: OnboardingStep) =>
            PATH.BRANCHES.IMPORT_STEP.BIND(branchId ?? '', step),
        [branchId],
    );
    const links = useStepStripLinks({
        mode: 'shell',
        currentStep,
        accountingNeeded: false,
        pathOf,
    });

    return (
        <StepStrip
            accountingNeeded={false}
            currentStep={currentStep}
            links={branchId === null ? undefined : links}
            mode="shell"
        />
    );
};
